// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 26294) return "static/chunks/0af98a8b-88021e0289220ac5.js";
	if (chunkId === 94150) return "static/chunks/18b16e15-0f8dc0803841ff20.js";
	if (chunkId === 39033) return "static/chunks/" + chunkId + "-60f8517820e3dda7.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 32237 ? "4aaa145a" : chunkId) + "." + {"24333":"32b3946098d0753d","24459":"3336fdd9d0d136ac","32237":"37c07d312c7f9839","40403":"3ecbc7e5b8799f08","52869":"489048021356814b","56354":"f5f163d7647d1305","93795":"f487380c0bb3bf3c","93841":"e39e474669047262"}[chunkId] + ".js";
};